export default {
    isFormOpen: state => state.formIsOpen,
    isGridOpen: state => state.gridIsOpen,

    getDataTableOptions: state => state.dataTableOptions,
    getActions: state => state.actions,
    getSearchFields: state => state.searchFields,
    getFormActions: state => state.formActions,
    getRowActions: state => state.rowActions,
    getHeaderFields: state => state.headerFields
}
